import { Box, Typography } from "@mui/material"
import { roundUp } from "../MetricGoalsTable/utils"
import { colors } from "../../../../styles/commonStyles"

const OpportunityCell = (props: any) => {
  const { column, row, renderedCellValue } = props

  const finalString: any = column?.id + "_datatype"

  const finalBackGroundColor: any = column?.id + "_color"

  return (
    <Box
      sx={{
        // border: "1px solid red",
        display: "flex",
        justifyContent: "center",
        width: "50%",
        p: "3px",
        margin: "0 auto",
        backgroundColor: `${
          row?.original?.[finalBackGroundColor] == "red"
            ? colors.primaryRed
            : row?.original?.[finalBackGroundColor] == "yellow"
            ? colors.primaryYellow
            : row?.original?.[finalBackGroundColor] == "green"
            ? colors.primaryGreen
            : "#FFFFFF"
        }`,
        color: `${
          row?.original?.[finalBackGroundColor] == "red"
            ? "#FFFFFF"
            : row?.original?.[finalBackGroundColor] == "yellow"
            ? "#000000"
            : row?.original?.[finalBackGroundColor] == "green"
            ? "#FFFFFF"
            : "#000000"
        }`,
      }}
    >
      <Typography>
        {renderedCellValue
          ? `${roundUp(
              renderedCellValue,
              row?.original?.[finalString],
              row?.original?.metric_precision,
            )}`
          : ``}
      </Typography>
    </Box>
  )
}

export default OpportunityCell
